import {
  Button,
  FormControlLabel,
  Grid,
  MenuItem,
  Switch,
  TextField,
} from '@mui/material'
import { isEqual } from 'lodash'
import { memo, useCallback, useContext, useEffect, useState } from 'react'
import { GlobalContext } from '../../../App'
import { metodoPrograma } from '../../../components/api'
import { Controller, useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'
import AutoComplete from '../../../components/AutoComplete/AutoComplete'

const retornaLocalAtendimento = (u = [], idLocalAtendimento = null) => ({
  idAgenda: u?.[0] || undefined,
  idLocalAtendimento: u?.[1] || idLocalAtendimento,
  cdMedico: u?.[2] || '',
  dsAgenda: u?.[3] || '',
  nrTempo: u?.[4] || '',
  snProgramacaoEnfermagem: u?.[11] || '',
  dsCorFundo: u?.[12] || '#b6d3c9',
  dsCorTexto: u?.[13] || '#000000',
  snAvaliacaoCheckin: u?.[15] || 'N',
  snSinaisVitais: u?.[16] || 'N',
  snAnamnese: u?.[17] || 'N',
  snExameFisico: u?.[18] || 'N',
  snDiangostico: u?.[19] || 'N',
  snConduta: u?.[20] || 'N',
  snTerapiaComplementar: u?.[21] || 'N',
  snSuplementoComplementar: u?.[22] || 'N',
  snHistoricoClinico: u?.[23] || 'N',
  snQuestionario: u?.[24] || 'N',
  snReceituario: u?.[25] || 'N',
  snAtestado: u?.[26] || 'N',
  dsNomeAvaliacaoDiagnostica: u?.[27] || '',
  snDocumentoHistorico: u?.[28] || 'N',
  snDocumentoExame: u?.[30] || 'N',
  dsNomeAnamnese: u?.[31] || '',
  snParecerPorIa: u?.[32] || 'N',
  snCurvaCrescimento: u?.[34] || 'N',
})

const nrTempos = [
  [5, '5 minutos'],
  [10, '10 minutos'],
  [15, '15 minutos'],
  [20, '20 minutos'],
  [25, '25 minutos'],
  [30, '30 minutos'],
  [35, '35 minutos'],
  [40, '40 minutos'],
  [45, '45 minutos'],
  [50, '50 minutos'],
  [55, '55 minutos'],
  [60, '60 minutos'],
]

const switches = [
  { name: 'snAvaliacaoCheckin', label: 'Avaliação do Check-in' },
  { name: 'snSinaisVitais', label: 'Registro de Sinais Vitais' },
  { name: 'snAnamnese', label: 'Registro Anamnese' },
  { name: 'snExameFisico', label: 'Registro de Exame Físico' },
  { name: 'snDiangostico', label: 'Registro de Diagnóstico' },
  { name: 'snConduta', label: 'Registro de Conduta' },
  {
    name: 'snTerapiaComplementar',
    label: 'Registro de Terapias Complementares',
  },
  {
    name: 'snSuplementoComplementar',
    label: 'Registro de Suplementos Complementares',
  },
  { name: 'snHistoricoClinico', label: 'Histórico Clínico' },
  { name: 'snQuestionario', label: 'Registro de Questionário' },
  { name: 'snAtestado', label: 'Registro de Atestado' },
  { name: 'snReceituario', label: 'Registro de Receituário' },
  { name: 'snDocumentoHistorico', label: 'Registro de Documento' },
  { name: 'snDocumentoExame', label: 'Registro de Exames' },
  { name: 'snParecerPorIa', label: 'Parecer técnico por IA' },
  { name: 'snCurvaCrescimento', label: 'Curva de Crescimento' },
]

const createAgenda = z.object({
  idAgenda: z.number().optional(),
  idLocalAtendimento: z.number(),
  cdMedico: z.number().min(1, {
    message: 'Selecione um médico',
  }),
  dsAgenda: z.string().min(3, {
    message: 'Nome da agenda inválido',
  }),
  nrTempo: z.number().min(1, {
    message: 'Selecione um tempo',
  }),
  snProgramacaoEnfermagem: z.string().min(1, {
    message: 'Selecione um Programação da Enfermagem',
  }),
  dsCorFundo: z.string().optional(),
  dsCorTexto: z.string().optional(),
  snAvaliacaoCheckin: z.string().optional(),
  snSinaisVitais: z.string().optional(),
  snAnamnese: z.string().optional(),
  snExameFisico: z.string().optional(),
  snDiangostico: z.string().optional(),
  snConduta: z.string().optional(),
  snTerapiaComplementar: z.string().optional(),
  snSuplementoComplementar: z.string().optional(),
  snHistoricoClinico: z.string().optional(),
  snQuestionario: z.string().optional(),
  snReceituario: z.string().optional(),
  snAtestado: z.string().optional(),
  dsNomeAvaliacaoDiagnostica: z.string().optional(),
  snDocumentoHistorico: z.string().optional(),
  snDocumentoExame: z.string().optional(),
  snParecerPorIa: z.string().optional(),
  snCurvaCrescimento: z.string().optional(),
  dsNomeAnamnese: z.string().optional(),
  idAgente: z.number().optional(),
})

const Edicao = ({ dados, voltar }) => {
  const { localAtendimento } = useContext(GlobalContext)
  const [medicos, setMedicos] = useState([])
  const [acQuestionario, setAcQuestionario] = useState(dados?.[14] || [])
  const [acTerapia, setAcTerapia] = useState(dados?.[29]?.[0] || [])
  const [acAgenteIA, setAcAgenteIA] = useState(dados?.[33]?.[0] || [])

  const {
    register,
    handleSubmit,
    watch,
    control,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(createAgenda),
    defaultValues: retornaLocalAtendimento(dados, localAtendimento[0]),
  })

  const getMedicos = useCallback(async () => {
    metodoPrograma(
      'lista',
      { idLocalAtendimento: localAtendimento[0] },
      'CtrlMedico',
    ).then((res) => {
      if (res.status) {
        setMedicos(res.lista)
      }
    })
  }, [localAtendimento])

  const salva = async (values) => {
    const obj = {
      ...values,
      questionarios: acQuestionario,
      idTerapia: acTerapia?.[0]?.[0],
      idAgente: acAgenteIA?.[0]?.[0],
    }
    const res = await metodoPrograma('salva', obj)
    if (res.status) voltar()
  }

  useEffect(() => {
    async function fetchData() {
      if (localAtendimento) {
        await getMedicos()
      }
    }
    fetchData()
  }, [getMedicos, localAtendimento])

  return (
    <form onSubmit={handleSubmit(salva)}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            {...register('dsAgenda')}
            label="Nome Agenda"
            size="small"
            fullWidth
            margin="dense"
            variant="outlined"
            error={!!errors.dsAgenda}
            helperText={errors.dsAgenda?.message}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            {...register('cdMedico')}
            value={watch('cdMedico')}
            label="Nome do Profissional"
            size="small"
            fullWidth
            margin="dense"
            variant="outlined"
            select
            error={!!errors.cdMedico}
            helperText={errors.cdMedico?.message}
          >
            {medicos.map((item) => (
              <MenuItem key={item[0]} value={item[0]}>
                {item[1]}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} sm={2}>
          <TextField
            {...register('nrTempo')}
            size="small"
            label="Tempo"
            fullWidth
            value={watch('nrTempo')}
            margin="dense"
            variant="outlined"
            select
            error={!!errors.nrTempo}
            helperText={errors.nrTempo?.message}
          >
            {nrTempos.map((item) => (
              <MenuItem key={item[0]} value={item[0]}>
                {item[1]}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} sm={2}>
          <TextField
            {...register('snProgramacaoEnfermagem')}
            label="Permitir programação da Enfermagem"
            fullWidth
            size="small"
            value={watch('snProgramacaoEnfermagem')}
            margin="dense"
            variant="outlined"
            select
            error={!!errors.snProgramacaoEnfermagem}
            helperText={errors.snProgramacaoEnfermagem?.message}
          >
            <MenuItem value={'N'}>Não</MenuItem>
            <MenuItem value={'S'}>Sim</MenuItem>
          </TextField>
        </Grid>

        <Grid item xs={12} sm={2}>
          <TextField
            {...register('dsCorFundo')}
            label="Cor de fundo"
            type="color"
            size="small"
            value={watch('dsCorFundo')}
            fullWidth
            margin="dense"
            variant="outlined"
            error={!!errors.dsCorFundo}
            helperText={errors.dsCorFundo?.message}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <TextField
            {...register('dsCorTexto')}
            label="Cor do Texto"
            type="color"
            size="small"
            value={watch('dsCorTexto')}
            fullWidth
            margin="dense"
            variant="outlined"
            error={!!errors.dsCorTexto}
            helperText={errors.dsCorTexto?.message}
          />
        </Grid>
        <Grid item xs={12} md={5}>
          <AutoComplete
            multiple
            InputLabelProps={{ shrink: true }}
            filterSelectedOptions
            label="Questionário aplicado no atendimento clínico"
            metodo="buscaQuestionario"
            value={acQuestionario}
            size="small"
            onChange={(_, val) => setAcQuestionario(val)}
          />
        </Grid>
        <Grid item xs={12} md={5}>
          <AutoComplete
            InputLabelProps={{ shrink: true }}
            filterSelectedOptions
            label="Terapia"
            metodo="buscaTerapia"
            value={acTerapia}
            size="small"
            onChange={(_, val) => setAcTerapia(val)}
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <AutoComplete
            InputLabelProps={{ shrink: true }}
            filterSelectedOptions
            label="Agente de IA"
            metodo="buscaAgenteIA"
            value={acAgenteIA}
            size="small"
            onChange={(_, val) => setAcAgenteIA(val)}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            {...register('dsNomeAvaliacaoDiagnostica')}
            label="Descrição do Campo para Avaliação Diangóstica"
            size="small"
            fullWidth
            margin="dense"
            variant="outlined"
            error={!!errors.dsNomeAvaliacaoDiagnostica}
            helperText={errors.dsNomeAvaliacaoDiagnostica?.message}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            {...register('dsNomeAnamnese')}
            label="Descrição do Campo para Anamnese"
            fullWidth
            size="small"
            margin="dense"
            variant="outlined"
            error={!!errors.dsNomeAnamnese}
            helperText={errors.dsNomeAnamnese?.message}
          />
        </Grid>

        <Grid item xs={12}>
          <Grid container spacing={2}>
            {switches.map((item) => (
              <Grid item xs={12} sm={3} key={item.name}>
                <Controller
                  name={item.name}
                  control={control}
                  render={({ field }) => (
                    <FormControlLabel
                      control={
                        <Switch
                          checked={field.value === 'S'}
                          onChange={(e) =>
                            field.onChange(e.target.checked ? 'S' : 'N')
                          }
                        />
                      }
                      label={item.label}
                    />
                  )}
                />
              </Grid>
            ))}
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          style={{ display: 'flex', flexDirection: 'row-reverse' }}
        >
          <Button
            type="submit"
            variant="contained"
            color="primary"
            style={{ margin: '5px' }}
          >
            Salvar
          </Button>
          <Button
            onClick={voltar}
            variant="contained"
            color="secondary"
            style={{ margin: '5px' }}
          >
            Cancelar
          </Button>
        </Grid>
      </Grid>
    </form>
  )
}

export default memo(Edicao, isEqual)
